var GraphicShape = require('./graphic'),
    ShapeUtils = require('./shapeUtils'),
    NormalizeNewLineCharacters = require('../../FV/util').normalizeNewLineCharacters,
    Raphael = require('raphael');


module.exports = GraphicShape.extend({

    VIEW_SUPPORTS_TRANSFORM: 1,
    ALLOW_DRAG_OFF_CANVAS: 1,

    /* TODO: Potential Issue if implement background -- would have 2 colors */
    /* For now we export as a group but import just the text element, which is what we work with */
    setZoneColorOnParse: function( raphaelAttrs, options ) {

        var color = !options.isNewlyDrawn
            ? raphaelAttrs.fill
            : this.parentNote.uiModel.get('textColor'); // raphaelAttrs wouldn't exist

        this.setZoneColor( color );

    },

    /**
     * This is much simpler than you think because we only render transformed --
     * just pass the original x, y coordinates, remove the transform, and store the rotation for reading back in.
     */
    getNormalizedElToPerist: function( ) {

        var noteUiModel = this.parentNote.uiModel;

        var shapeRotation = noteUiModel.get('rotationAtZeroPageRotation') % 360;
        shapeRotation = parseFloat( shapeRotation ); // if -0, make it 0 -- should also set before here

        var stampModel = noteUiModel.getSelectedStamp();

        /* nonViewTransform now not used here, we break up for rotation and text offset to export */
        var shapeTransformModel = this.getTransformModel();

        var noViewRotateTransform = shapeTransformModel.getNonViewRotateTransform();
        var textYOffsetTransform = shapeTransformModel.getTextYOffsetTransform();


        // Clone: give some consistency with the other shapes; will still allow to use Raphael's attributes
        // later when move off Raphael, can just deal with the actual attributes
        var el = this.uiModel.get('raphaelEl');
        var clone = el.clone();

        // Raphael applies this to the style element; it not a direct attribute
        // further .attr() does not affect the underlying DOM element, it attaches a property to the Rapha�l object ( its the CSS(!) cursor )
        clone.node.style.removeProperty('cursor');

        // actually its on the style element
        clone.setStrokeAndFill( this.getZoneColor() ); // change the color to persist, in case it was overwritten (eg by consult group )

        clone.attr({
            transform: textYOffsetTransform,
            x: +(el.attr('x' ).toFixed( 3 )),
            y: +(el.attr('y' ).toFixed( 3 ))
        });


        var SVG_NAMESPACE_XMLS = 'http://www.w3.org/2000/xmlns/';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var FEITH_STAMP_NAMESPACE = 'http://www.feith.com/graphic_text_stamp';
        var TEXT_ELEMENT_CLASS_NAME = 'gts_text';


        // TODO: if leave this logic -- put fn to share it with shapes.toSVG -- getSVGCanvasDimensions to save
        // Awaiting Tom to see appropriate logic

        var pageDimensions = this.pageModel.isCold()
            ? { width: '100%', height: '100%' }
            : this.pageModel.getOriginalPageCanvasDimensions();

        if ( !this.pageModel.isCold() ) {
            pageDimensions.width = pageDimensions.w + 'px';
            pageDimensions.height =  pageDimensions.h +'px';
        }

        var variableInputs = noteUiModel.getVariableInputs(),
            tokenInputs = noteUiModel.getTokenInputs();

        var svg = document.createElementNS( SVG_NAMESPACE, 'svg');
        svg.setAttribute( 'width', pageDimensions.width );
        svg.setAttribute( 'height', pageDimensions.height );
        svg.setAttribute( 'version', '1.1' );
        svg.setAttributeNS( SVG_NAMESPACE_XMLS, 'xmlns', 'http://www.w3.org/2000/svg' );
        svg.setAttributeNS( SVG_NAMESPACE_XMLS, 'xmlns:xlink', 'http://www.w3.org/1999/xlink' );


        /* Now creating the meta-data element -- could have attributes */
        var metadataTag = document.createElementNS( SVG_NAMESPACE, 'metadata' );
        var stampMetaDataXml = createStampNSElement( 'stamp' );

        stampMetaDataXml.appendChild( createStampNSElement( 'version', noteUiModel.getVersion().toString() ) ); // ( needs to be a string to write )
        stampMetaDataXml.appendChild( createStampNSElement( 'id', stampModel.get('id').toString() ) );
        stampMetaDataXml.appendChild( createStampNSElement( 'rotation', shapeRotation.toString() ) );
        stampMetaDataXml.appendChild( createStampNSElement( 'subject', stampModel.get('subject') ) );

        /* Normalize should already be complete by now but doesn't hurt */
        stampMetaDataXml.appendChild( createStampNSElement( 'template', NormalizeNewLineCharacters( stampModel.getText() ) ) ); // already normalized but again do in case
        stampMetaDataXml.appendChild( createStampNSElement( 'content', NormalizeNewLineCharacters( clone.attr('text') ) ));  // already normalized but done again

        if ( variableInputs && variableInputs.length > 0 ) {

            var variableInputsTag = createStampNSElement( 'variables' );
            variableInputs.each( function( vi ) {
                variableInputsTag.appendChild( createInputElement( 'variable', vi.get('key'), vi.get('value') ) );
            });

            stampMetaDataXml.appendChild( variableInputsTag );
        }

        if ( tokenInputs && tokenInputs.length > 0 ) {

            var tokenInputsTag = createStampNSElement( 'tokens' );
            tokenInputs.each( function( vi ) {
                tokenInputsTag.appendChild( createInputElement( 'token', vi.get('key'), vi.get('value') ) );
            });

            stampMetaDataXml.appendChild( tokenInputsTag );
        }

        metadataTag.appendChild( stampMetaDataXml );
        svg.appendChild( metadataTag );

        /* create g with the non rotate part of the transform */
        var g = document.createElementNS( SVG_NAMESPACE, 'g' );
        g.setAttribute( 'class', 'gts_top_group' );

        // Move the 'ROTATION' transform to the top level group element -- text element is different
        // Note: both transforms (both here and on the text element are currently ignored by this app ( svgImport ) -- this just
        // read in the text element now, and the code later applies the appropriate transforms via the calculations used to create it
        if ( shapeRotation !== 0 ) {

            //  el.setAttribute(key, Str(attr[key])); -- if have transform string to mx fn -- don't need the el
            var dummyPath =  el.paper.path('');

            dummyPath.transform(  noViewRotateTransform  ); // hack to get the transform on the element -- would only exist if new on page rotation other than 0

            g.setAttribute( 'transform',  dummyPath.node.getAttribute('transform') );

            dummyPath.remove();

        }


        /* Remove pixels from the font size -- Raphael only allows us to use pixels, but we don't need to store it as such
        /* This is consistent with all the other values we are working with -- just use user units */
        clone.node.setAttribute( 'font-size', parseFloat( clone.node.getAttribute('font-size') ) );


        /**
         * Modify the text attribute
         * Stroke-width: svg stroke is none by default but Raphael 'transform' fn will give this a value even if one doesn't exist; this messes up glow and is not necessary for storage.
         */
        clone.node.removeAttribute('stroke-width');

        /** Always review stroke -- it is set as 'none' **/

        clone.node.removeAttribute('stroke');

        /** Don't store attributes if they are default SVG values */

        if ( parseFloat( clone.node.getAttribute('opacity') ) === 1  ) {
            clone.node.removeAttribute('opacity');
            clone.node.style.removeProperty('opacity');
        }

        /* Remove the style attribute -- currently not necessary */

        clone.node.removeAttribute('style');

        /* Put a class identfier on the text element ( can't do with Raphael ) */
        clone.node.setAttribute( 'class', TEXT_ELEMENT_CLASS_NAME );

        /** Round the tspans and remove unused style attributes -- slice for IE **/
        /* Note: we need the x attributes */
        Array.prototype.forEach.call( clone.node.childNodes, function( tSpan ) {

            tSpan.setAttribute('style',''); // for some reason, need to set to empty before removal ( could use jQuery -- but see jQuery source for explanation )
            tSpan.removeAttribute('style');
            tSpan.setAttribute( 'dy', parseFloat( tSpan.getAttribute('dy') ).toFixed( 3 ) );

        });


        g.appendChild( clone.node ); // this won't working being added to set

        /* --- TEST print of dummy bkgnd to see how would look on export -- in real world would want under the text.
        var box = el.getBBox(1);
        var dummyRect =  el.paper.rect( el.attr('x'), el.attr('y'), box.width, box.height).attr({
            fill: 'green',
            opacity: 0.5
        });
         g.appendChild( dummyRect.clone().node  ); // clone for remove


         dummyRect.remove();
         ---- */

        svg.appendChild( g );

        var svgXML = new XMLSerializer().serializeToString( svg ); // for IE, need the XMLSeriealizer; otherwise use svg.outerHTML;

        //console.log( svgXML );

        clone.remove(); // this also takes out of the new element

        return svgXML;


        function createStampNSElement( tagName, value ) {

            var tag = document.createElementNS( FEITH_STAMP_NAMESPACE, tagName );
            if ( value && value.length > 0 ) {
                tag.textContent = value; // textContent for IE
            }
            return tag;

        }

        function createInputElement( tagName, key, value ) {

            var tag = document.createElementNS( FEITH_STAMP_NAMESPACE, tagName );
            tag.setAttribute( 'key', key );
            tag.textContent = value; // textContent for IE
            return tag;

        }


    }


});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/textStamp.js
 ** module id = 321
 ** module chunks = 0
 **/